import { NUMBER_TYPE } from '@/utils/constants';

export default {
  app: 'https://play.google.com/store/apps/details?id=com.recarga.saldo1.claro.pa.app',
  setNumber: 'Ya puedes pagar o activar tu Débito Automático Mensual de tu línea móvil y Claro Hogar de manera fácil y segura.',
  profiles: [
    {
      key: NUMBER_TYPE[1],
      checkboxLabel: 'Móvil',
      inputLabel: 'Digita tu número telefónico'
    },
    {
      key: NUMBER_TYPE[0],
      checkboxLabel: 'Claro TV/Claro Hogar',
      inputLabel: 'Digita tu número de contrato'
    },
    {
      key: NUMBER_TYPE[4],
      checkboxLabel: 'Corporativo Móvil',
      inputLabel: 'Digita tu número corporativo'
    }
  ]
};
